import type { MenuItemControlProps } from '@1js/acui-ribbon-like/lib/UISurfaces/controls/Menu';
import { constructKeytip, getKeytipString } from 'owa-command-ribbon';
import { ControlInfo, getControlInfo } from 'owa-mail-ribbon-utils';
import { MailRibbonControlId, MailRibbonTabId } from 'owa-ribbon-ids';
import { getReadRibbonId } from '../../util/getReadRibbonId';
import { createMailAppButton } from '../../util/createMailRibbonButton';
import { onForwardEmailAsAttachmentClicked, onForwardClicked } from '../../util/commandActions';
import type { ClientItemId } from 'owa-client-ids';

/**
 * This function returns the drop-down content of the "Forward" button in the Ribbon.
 *
 * @returns an array with the controls for the forward split button
 */
export default function getForwardControls(
    itemId?: ClientItemId,
    targetWindow?: Window
): MenuItemControlProps[] {
    const controls: MenuItemControlProps[] = [];

    const forwardControlId = MailRibbonControlId.RespondForward;
    const forwardControlInfo: ControlInfo = getControlInfo(MailRibbonControlId.RespondForward);

    const forwardAttachmentControlId = MailRibbonControlId.RespondForwardEmailAsAttachment;
    const forwardAttachmentControlInfo: ControlInfo = getControlInfo(forwardAttachmentControlId);

    controls.push(
        createMailAppButton(
            getReadRibbonId(forwardControlId, itemId),
            forwardControlInfo.text,
            forwardControlInfo.tooltip,
            itemId !== undefined,
            onForwardClicked(itemId, targetWindow),
            constructKeytip(
                [
                    getKeytipString(MailRibbonTabId.Tab_Home),
                    getKeytipString(MailRibbonControlId.RespondForward),
                ],
                getKeytipString(MailRibbonControlId.RespondForward)
            ),
            forwardControlInfo.iconName
        )
    );

    controls.push(
        createMailAppButton(
            getReadRibbonId(forwardAttachmentControlId, itemId),
            forwardAttachmentControlInfo.text,
            forwardAttachmentControlInfo.tooltip,
            itemId !== undefined,
            onForwardEmailAsAttachmentClicked(itemId, targetWindow),
            constructKeytip(
                [
                    getKeytipString(MailRibbonTabId.Tab_Home),
                    getKeytipString(MailRibbonControlId.RespondForward),
                ],
                getKeytipString(MailRibbonControlId.RespondForwardEmailAsAttachment)
            ),
            forwardAttachmentControlInfo.iconName
        )
    );

    return controls;
}
